import { commonAction } from '../actions/common'
import { commonMutation } from '../mutations/common'

export const common = {
  state: {
    'cdzx/config': {
      data: {}
    },
    'activityinfo': {
      data: {}
    },
    'patchinfo': {
      data: {}
    },
    'lotteryinfo': {
      data: {}
    },
    'activityindexinfo': {
      data: {}
    },
    'annualreport': {
      data: {}
    },
    'loan/paraminfo': {
      data: {}
    },
    'loan/recproducts': {
      data: {}
    },
    'loan/showrecway': {
      data: {}
    },
    'loan/myorder': {
      data: {}
    }
  },
  mutations: commonMutation,
  actions: commonAction,
}
